import { getBlogDetailPath } from "../../../core/schema/paths/getBlogDetailPath.js";
import type { ArticleForCard, CardItem } from "./ArticleCardProps.js";

export function newsToCard(news: ArticleForCard): CardItem {
	return {
		title: news.title,
		perex: news.perex,
		primaryImage: news.primaryImage,
		href: `/${getBlogDetailPath(news)}`,
	};
}
